import React from 'react'

import ServiceOrdersLoader from './_load/ServiceOrdersLoader'
import ServiceOrderCardV2 from '../../../containers/serviceOrders/ServiceOrderCardV2'

import { useGetAllServiceOrders } from '../../../containers/serviceOrders/SelectAllServiceOrdersLink'
import MultiSelectHandler from '../../../packages/kiti/components/multiSelect/MultiSelectHandler'
import MultiSelectToggler from '../../../components/actions/MultiSelectToggler'
import ListCounter from '../shared/ListCounter'
import ControlBar from '../shared/ControlBar'
import ColumnsList from './ColumnsList'
import MultiRowsActions from '../list/table/MultiRowsActions'
import { useLocalStorageWatcher } from '../../../utils/helpers/localStorage'

const PageContent = ({ id }) => {
  useLocalStorageWatcher('LAST_PROCESS_VIEW_MODE', 'kanban')

  return (
    <MultiSelectHandler>
      <ControlBar hideFastFilters leftContent={<MultiSelectToggler />} selectedScreen={`/processes/kanban/${id}`} />
      <ColumnsList
        Loader={ServiceOrdersLoader}
        Card={ServiceOrderCardV2}
        Counter={props => <ListCounter {...props} flexiblePollInterval={30000} />}
        useGetAll={useGetAllServiceOrders}
      />
      <MultiRowsActions />
    </MultiSelectHandler>
  )
}

export default PageContent
